import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'particles/themes/styled'
import Text from 'particles/Text'

interface Props {
    showSlowMessage?: boolean
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    gap: ${({ theme }) => theme.spacing[600]};
    background-color: ${({ theme }) => theme.colors.surface.primary};
`

const Animation = styled.video`
    width: auto;
    height: 200px;
`

const TextGroup = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    gap: ${({ theme }) => theme.spacing[200]};
    width: 500px;
    max-width: 90%;
`

const GeneralLoading: React.FC<Props> = ({ showSlowMessage }) => {
    const [t] = useTranslation()

    return (
        <Wrapper>
            <Animation src="/partireading.mp4" autoPlay loop muted playsInline />
            <TextGroup>
                <Text scale="H4" color="secondary">
                    {t('loadingState.loadingGenericPageSubtitle')}
                </Text>
                <Text scale="bodyL400" color="secondary" style={{ visibility: showSlowMessage ? 'visible' : 'hidden' }}>
                    {t('general.loading.caption')}
                </Text>
            </TextGroup>
        </Wrapper>
    )
}

export default GeneralLoading
